"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresentionManager = void 0;
class PresentionManager {
    constructor(observableEntity) {
        this.observableEntity = observableEntity;
        this.internalDoUodateView = () => {
            this.doUpdateView();
        };
        this.dispose = () => {
            this.observableEntity.removeObserver(this.internalDoUodateView);
        };
        observableEntity.addObserver(this.internalDoUodateView);
    }
}
exports.PresentionManager = PresentionManager;
